<template>
  <div id="">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-upload
            class="upload"
            action=""
            accept="image/jpeg,image/jpg,image/png"
            :file-list="fileList"
            :show-file-list="true"
            :on-change="onChange"
            :http-request="uploadFile"
            multiple>
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过100kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.name" placeholder="查询条件"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="el-form-button" type="primary" v-on:click="loadData">查询</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="id"
      border
      lazy
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column label="图片" show-overflow-tooltip width="100">
        <template slot-scope="scope">
          <el-image
            :src="'data:image/jpg;base64,'+scope.row.data" />
        </template>
      </el-table-column>
      <!--第二步  开始进行修改和查询操作-->
      <el-table-column label="操作" align="center" min-width="100">
        <template slot-scope="scope">
          <el-button type="danger" @click="deleteHead(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <PageGroup v-bind:pageInfo="pageInfo" @pageChange="loadData"></PageGroup>

  </div>
</template>

<script>
import {HttpResp} from '../../constant/index';
import {likeApi} from '../../api/index';
import PageGroup from "../template/PageGroup";

export default {
  name: 'LikeHead',
  components: {PageGroup},
  data() {
    return {
      tableData: [],
      addFormReadOnly: true,
      dialogVisible: false,
      isView: true,
      modifyTag: false,
      addFormData: {
        id: '',
        level: '',
        parentId: '',
        name: '',
        url: '',
        permissionCode: '',
        style: ''
      },

      filters: {
        name: ''
      },

      pageInfo: {
        pageNumber: 1, //默认在第一页
        pageSize: 10, //默认每页显示1条数据
        total: 1, //默认总条数为一条
      },

      defaultProps: {
        children: 'children',
        label: 'label'
      },

      fileList: []
    }
  },
  mounted: function () {
    this.loadData();
  },
  computed: {

  },
  methods: {
    loadData() {
      let param = {
        pageNumber: this.pageInfo.pageNumber,
        pageSize: this.pageInfo.pageSize,
        filter: this.filters.name
      };
      likeApi.page(param).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          this.tableData = data.data.dataList;
          this.pageInfo.total = data.data.total;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    addInfo() {
      this.addFormData = {
        id: '',
        level: '',
        parentId: 0,
        name: '',
        url: '',
        permissionCode: '',
        style: ''
      };
      this.isView = true;
      this.modifyTag = false;
      this.dialogVisible = true;
    },
    deleteHead(headId) {
      this.$confirm('是否删除这条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        likeApi.delHead(headId).then(data => {
          if(data.code == HttpResp.SUCCUSS){
            this.$message({
              type: 'success',
              message: "删除成功"
            });
            this.loadData();
          }else{
            this.$message({
              type: 'error',
              message: data.message
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    uploadFile(upload) {
      let data = new FormData();
      data.append('file', upload.file);
      likeApi.addHead(data).then(data => {
        if(data.code == HttpResp.SUCCUSS){
          // 显示成功数据
          this.fileList.push(upload.file)
          this.$message({
            type: 'success',
            message:"上传成功"
          });
          // 刷新列表
          this.loadData();
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    onChange(file, fileList) {
      // 清空上传文件列表，防止上传失败也显示在列表上
      this.fileList = []
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/components/like/LikeHead.vue